export var GooglePayEventTypeEnumsObj = {
    SDK_NOT_INITIALIZED: "SDK_NOT_INITIALIZED",
    BUTTON_RENDERED: "BUTTON_RENDERED",
    BUTTON_NOT_RENDERED_ALREADY_EXISTS: "BUTTON_NOT_RENDERED_ALREADY_EXISTS",
    BUTTON_RENDER_ERROR: "BUTTON_RENDER_ERROR",
    BUTTON_RENDER_FAIL_BUTTON_PARAMS_VALIDATION_ERROR: "BUTTON_RENDER_FAIL_BUTTON_PARAMS_VALIDATION_ERROR",
    BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS: "BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS",
    BUTTON_CLICK: "BUTTON_CLICK",
    DEVICE_READY_TO_PAY: "DEVICE_READY_TO_PAY",
    DEVICE_NOT_READY_TO_PAY: "DEVICE_NOT_READY_TO_PAY",
    SDK_INITIALIZE_SUCCESS: "SDK_INITIALIZE_SUCCESS",
    SDK_INITIALIZE_ERROR: "SDK_INITIALIZE_ERROR",
    SDK_INITIALIZE_FAIL_DEVICE_NOT_READY_TO_PAY: "SDK_INITIALIZE_FAIL_DEVICE_NOT_READY_TO_PAY",
    PAYMENT_STARTING: "PAYMENT_STARTING",
    PAYMENT_STARTED: "PAYMENT_STARTED",
    PAYMENT_STARTING_ERROR: "PAYMENT_STARTING_ERROR",
    PAYMENT_COMPLETION_STARTING: "PAYMENT_COMPLETION_STARTING",
    PAYMENT_COMPLETION_STARTED: "PAYMENT_COMPLETION_STARTED",
    PAYMENT_COMPLETION_ERROR: "PAYMENT_COMPLETION_ERROR",
    PAYMENT_COMPLETION_OK: "PAYMENT_COMPLETION_OK",
    PAYMENT_COMPLETION_NOK: "PAYMENT_COMPLETION_NOK",
    PAYMENT_COMPLETION_REQUIRED_3DS: "PAYMENT_COMPLETION_REQUIRED_3DS",
};
